import { formatLabel } from "../../utils/catalogDisplay";
import { getVoiceSampleLanguageLabels } from "./detailUtils";
import CatalogDetailCompactChips from "./CatalogDetailCompactChips";

export default function CatalogEntryVoiceSamplesPanel({
  entry,
  selectedLaunchConfiguration = null
}) {
  const targetPopulation =
    entry?.metadata?.population?.target || [];
  const voiceContext =
    entry?.metadata?.population?.conditions || [];
  const voiceSampleLanguages = getVoiceSampleLanguageLabels(
    entry,
    selectedLaunchConfiguration
  );

  const hasContent = Boolean(
    targetPopulation.length ||
      voiceContext.length ||
      voiceSampleLanguages.length
  );

  if (!hasContent) {
    return null;
  }

  return (
    <section className="catalog-detail__panel catalog-detail__panel--metadata-rows">
      <h2>Voice samples</h2>

      <dl>
        {targetPopulation.length > 0 ? (
          <div>
            <dt>Target population</dt>
            <dd>
              <CatalogDetailCompactChips
                values={targetPopulation.map((value) => formatLabel(value))}
              />
            </dd>
          </div>
        ) : null}

        {voiceContext.length > 0 ? (
          <div>
            <dt>Voice context</dt>
            <dd>
              <CatalogDetailCompactChips
                values={voiceContext.map((value) => formatLabel(value))}
              />
            </dd>
          </div>
        ) : null}

        {voiceSampleLanguages.length > 0 ? (
          <div>
            <dt>Voice sample language</dt>
            <dd>
              <CatalogDetailCompactChips values={voiceSampleLanguages} />
            </dd>
          </div>
        ) : null}
      </dl>
    </section>
  );
}
